<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<p class="h2f1"><span class="right_1" epub:type="pagebreak" id="page_4" title="4">CONTENTS</span></p>
<p class="image0b"><img alt="" height="3" src="images/line.jpg" width="800"/></p>
<p class="toc0" id="book"><a href="#/text/Book">How to Use This Book</a></p>
<p class="toc" id="pt1"><a href="#/text/Part001">Part I: Organization</a></p>
<p class="toc1" id="ch1"><span class="hide">     </span><a href="#/text/Chapter001">Chapter 1: Introduction to Creative Journaling</a></p>
<p class="toc1" id="ch2"><span class="hide">     </span><span href="#/text/Chapter002" title="Link target outside of Sample">Chapter 2: Supplies &amp; Tools</span></p>
<p class="toc1" id="ch3"><span class="hide">     </span><span href="#/text/Chapter003" title="Link target outside of Sample">Chapter 3: Tips &amp; Tricks</span></p>
<p class="toc1" id="ch4"><span class="hide">     </span><span href="#/text/Chapter004" title="Link target outside of Sample">Chapter 4: Building a Foundation</span></p>
<p class="toc1" id="ch5"><span class="hide">     </span><span href="#/text/Chapter005" title="Link target outside of Sample">Chapter 5: Planning Pages &amp; Templates</span></p>
<p class="toc" id="pt2"><span href="#/text/Part002" title="Link target outside of Sample">Part II: Inspiration</span></p>
<p class="toc1" id="ch6"><span class="hide">     </span><span href="#/text/Chapter006" title="Link target outside of Sample">Chapter 6: Special Pages &amp; Collections</span></p>
<p class="toc1" id="ch7"><span class="hide">     </span><span href="#/text/Chapter007" title="Link target outside of Sample">Chapter 7: Header Styles</span></p>
<p class="toc1" id="ch8"><span class="hide">     </span><span href="#/text/Chapter008" title="Link target outside of Sample">Chapter 8: Banners, Frames, &amp; Borders</span></p>
<p class="toc1" id="ch9"><span class="hide">     </span><span href="#/text/Chapter009" title="Link target outside of Sample">Chapter 9: Doodle Embellishments</span></p>
<p class="toc1" id="ch10"><span class="hide">     </span><span href="#/text/Chapter010" title="Link target outside of Sample">Chapter 10: Inspiration from Real Journals</span></p>
<p class="toc" id="res"><span href="#/text/Resources" title="Link target outside of Sample">Resources</span></p>
<p class="toc" id="ack"><span href="#/text/Acknowledgments" title="Link target outside of Sample">Acknowledgments, and About the Author</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?007b726e